// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
interface ValidationInputProps extends React.PropsWithChildren<{}>, HtmlInputElementAttributes {
    onChange: (event: any, obj: INameValueObject ) => void;
    className?: string;
    readOnly?: boolean;
    autocomplete?: string;
    autofocus?: boolean;
    validation: IValidationObject;
}

interface ValidationInputState {
    
}

class ValidationInput extends React.Component<ValidationInputProps, ValidationInputState> {
    _hoverRef = createRef<HTMLDivElement>();

    constructor(props: ValidationInputProps) {
        super(props);

    }

    private _onChange = (event: any) => {
        var changeObj = {
            name: event.target.name,
            value: event.target.value
        };

        this.props.onChange(event, changeObj);
    }

    private _displayMessage = (event: any) => {
        (this._hoverRef.current as HTMLDivElement).style.display = 'block';
    }

    private _hideMessage = (event: any) => {
        (this._hoverRef.current as HTMLDivElement).style.display = '';
    }

    UNSAFE_componentWillReceiveProps = (nextProps: ValidationInputProps) => {
        // will hide the message in case the user has the mouse 
        // hovered over the element when changing the value
        if ((this._hoverRef.current as HTMLDivElement).style.display.length > 0 &&
            !nextProps.validation.invalidValue) {
            (this._hoverRef.current as HTMLDivElement).style.display = '';
        }
    }   


    render() {        
        return (
            <div className={`validation-input${this.props.validation.invalidValue ? ' has-error has-feedback' : ''}`}>
                <input type={this.props.type} id={this.props.id} className={this.props.className} readOnly={this.props.readOnly} autoComplete={this.props.autocomplete} autoFocus={this.props.autofocus}
                    placeholder={this.props.placeholder} value={this.props.value} name={this.props.name} onChange={this._onChange}></input>

                {this.props.validation.invalidValue ?
                    <span className="validation-input-feedback glyphicon glyphicon-remove form-control-feedback"
                        onMouseOver={this._displayMessage} onMouseOut={this._hideMessage} aria-hidden="true"></span> : null}

                {this.props.validation.invalidInput ?
                    <span className='invalid'>
                        <span className='icon-exclaimation'></span>{this.props.validation.invalidInputMessage}
                    </span> : null}

                <div ref={this._hoverRef} className='validation-input-feedback-msg'>{this.props.validation.invalidValueMessage}</div>
            </div>
        );
    }
}

export default ValidationInput;